import React from 'react';
import PropTypes from 'prop-types';
import H4 from 'sushiweb/Typography/Heading/H4';
import { P } from 'sushiweb/Typography/Text';
import { HeadingContainer } from '../styles';

const Heading = ({ heading, subheading }) => {
  return (
    <HeadingContainer>
      <H4>{heading}</H4>
      <P>{subheading}</P>
    </HeadingContainer>
  );
};

Heading.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
};

Heading.defaultProps = {
  heading: '',
  subheading: '',
};

export default Heading;
